import { FC } from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { SubmenuType } from '@/config/navigationPages';
import { checkItemActive } from '../../SidebarNavSubmenuLink.helpers';
import NestedSubmenu from '../NestedSubmenu';

import styles from './SubmenuItem.module.sass';

interface SubmenuItemProps {
  item: SubmenuType;
  locationPathname: string;
}

const SubmenuItem: FC<SubmenuItemProps> = ({ item, locationPathname }) => {
  const { t } = useTranslation();
  const isSubLinkActive = checkItemActive(item, locationPathname);

  const nestedSubMenu = item.subMenu ? Object.values(item.subMenu) : null;
  const shouldShowNested =
    isSubLinkActive && nestedSubMenu && nestedSubMenu.length > 0;

  const submenuClasses = cx(styles.sublink, {
    [styles['is-active']]: isSubLinkActive,
  });

  if (!item.i18NameKey) return null;

  return (
    <>
      <Link className={submenuClasses} to={item.path}>
        <span className={styles.text}>{t(item.i18NameKey)}</span>
      </Link>
      {shouldShowNested && (
        <NestedSubmenu
          items={nestedSubMenu}
          locationPathname={locationPathname}
          level={2}
        />
      )}
    </>
  );
};

export default SubmenuItem;
